import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';
import PropTypes from 'prop-types';

const StyledAlert = withStyles((theme) => ({
  root: {
    fontSize: theme.typography.subtitle1.fontSize,
    justifyContent: 'center',
    padding: theme.spacing(3)
  },
  icon: {
    fontSize: '33px',
    padding: 0
  },
  message: {
    padding: '6px 0'
  },
  standardError: {
    color: '#000000'
  }
}))(MuiAlert);

const Alert = props => {
  return <StyledAlert severity={props.severity}>{props.children}</StyledAlert>
};

Alert.propTypes = {
  severity: PropTypes.oneOf(['error', 'warning', 'info', 'success']),
  children: PropTypes.any
}

export default Alert;
